import React, { ReactElement } from "react";
import * as Accordion from "@radix-ui/react-accordion";
import { ChevronDown } from "@untitled-ui/icons-react";
import Link from "next/link";
import styles from "./mobileAccordionMenu.module.scss";

export const MobileAccordionMenu = (props: Props): ReactElement => {
  return (
    <div
      style={{
        overflowY: "scroll",
        height: "100%",
        //@ts-ignore
        height: "-webkit-fill-available",
      }}
    >
      <Accordion.Root
        type="multiple"
        style={{ display: "flex", flexDirection: "column", gap: "8px" }}
      >
        {props.menus?.map((item, i) => {
          if (item.variant == "destructive") {
            return (
              <button
                key={i}
                className={styles.destructive}
                onClick={item.onClick}
              >
                {item.title}
              </button>
            );
          } else if (item.url) {
            return (
              <Link
                key={i}
                className={styles.link}
                href={item.url}
                onClick={item.onClick}
                locale={false}
              >
                {item.title}
                {item.affix}
              </Link>
            );
          } else {
            return (
              <Accordion.Item
                key={i}
                value={i + ""}
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <Accordion.Trigger asChild>
                  <div className={styles.trigger}>
                    {item.title}
                    <ChevronDown
                      style={{
                        transition: "transform 150ms ease",
                      }}
                    />
                  </div>
                </Accordion.Trigger>
                <Accordion.Content asChild>
                  <div className={styles.content}>
                    {item.items?.map((menuItem, j) => (
                      <Link
                        key={j}
                        href={menuItem.url}
                        className={styles.itemLink}
                        onClick={menuItem.onClick}
                      >
                        {menuItem.icon}
                        <span className={styles.itemLinkText}>
                          {menuItem.title}
                        </span>
                      </Link>
                    ))}
                  </div>
                </Accordion.Content>
              </Accordion.Item>
            );
          }
        })}
      </Accordion.Root>
    </div>
  );
};

interface Props {
  menus: {
    title: string;
    url?: string;
    affix?: JSX.Element;
    items?: {
      title: string;
      desc?: string;
      icon?: JSX.Element;
      url: string;
      onClick?: () => void;
    }[];
    onClick?: () => void;
    variant: "regular" | "destructive";
  }[];
}
